import {
  FormControl,
  FormControlLabel,
  Checkbox,
  TextField,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import {
  type ITextAttribute,
  type INumberAttribute,
  type IFunctionAttribute,
  type IMonetaryValueAttribute,
  functionTypeOptionsMap,
  type IDateAttribute,
  type IBooleanAttribute,
} from '../../../Interfaces/ILegalTransactionMeasure';

export const TextAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: ITextAttribute;
  setAttribute: (attribute: ITextAttribute) => void;
}) => {
  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        label='Name'
        fullWidth
        value={attribute.Name}
        onChange={e => setAttribute({ ...attribute, Name: e.target.value })}
      />
      <FormControl fullWidth sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={attribute.Required}
              onChange={e =>
                setAttribute({
                  ...attribute,
                  Required: e.target.checked as boolean,
                })
              }
            />
          }
          label='Wert ist erforderlich'
        />
      </FormControl>
    </>
  );
};

export const NumberAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: INumberAttribute;
  setAttribute: (attribute: INumberAttribute) => void;
}) => {
  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        label='Name'
        fullWidth
        value={attribute.Name}
        onChange={e => setAttribute({ ...attribute, Name: e.target.value })}
      />
      <FormControl fullWidth sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={attribute.Required}
              onChange={e =>
                setAttribute({
                  ...attribute,
                  Required: e.target.checked as boolean,
                })
              }
            />
          }
          label='Wert ist erforderlich'
        />
      </FormControl>
    </>
  );
};

export const FunctionAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: IFunctionAttribute;
  setAttribute: (attribute: IFunctionAttribute) => void;
}) => {
  return (
    <>
      <FormControl variant='outlined' fullWidth sx={{ mt: 1 }}>
        <InputLabel id='function-type-label'>Funktion wählen</InputLabel>
        <Select
          fullWidth
          labelId='function-type-label'
          label='Funktion wählen'
          value={attribute.idSF}
          onChange={e =>
            setAttribute({
              ...attribute,
              idSF: e.target.value as number,
              Name: functionTypeOptionsMap[e.target.value as number] as
                | 'Handelsregister Nachverfolgung'
                | 'Zahlungsrechner'
                | 'Gesellschafterliste Nachverfolgung'
                | 'Grundbuch Nachverfolgung',
            })
          }
        >
          {
            //TODO: replace [1, 2, 3] with an array of all function types
            [1, 2, 3, 4].map(option => (
              <MenuItem key={option} value={option}>
                {functionTypeOptionsMap[option]}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    </>
  );
};

export const CurrencyAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: IMonetaryValueAttribute;
  setAttribute: (attribute: IMonetaryValueAttribute) => void;
}) => {
  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        label='Name'
        fullWidth
        value={attribute.Name}
        onChange={e => setAttribute({ ...attribute, Name: e.target.value })}
      />
      <FormControl fullWidth sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={attribute.Required}
              onChange={e =>
                setAttribute({
                  ...attribute,
                  Required: e.target.checked as boolean,
                })
              }
            />
          }
          label='Wert ist erforderlich'
        />
      </FormControl>
    </>
  );
};

export const BooleanAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: IBooleanAttribute;
  setAttribute: (attribute: IBooleanAttribute) => void;
}) => {
  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        label='Name'
        fullWidth
        value={attribute.Name}
        onChange={e => setAttribute({ ...attribute, Name: e.target.value })}
      />
      <FormControl fullWidth sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={attribute.Required}
              onChange={e =>
                setAttribute({
                  ...attribute,
                  Required: e.target.checked as boolean,
                })
              }
            />
          }
          label='Wert ist erforderlich'
        />
      </FormControl>
    </>
  );
};

export const DateAttributeFields = ({
  attribute,
  setAttribute,
}: {
  attribute: IDateAttribute;
  setAttribute: (attribute: IDateAttribute) => void;
}) => {
  return (
    <>
      <TextField
        sx={{ mt: 1 }}
        label='Name'
        fullWidth
        value={attribute.Name}
        onChange={e => setAttribute({ ...attribute, Name: e.target.value })}
      />
      <FormControl fullWidth sx={{ mt: 2 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={attribute.Required}
              onChange={e =>
                setAttribute({
                  ...attribute,
                  Required: e.target.checked as boolean,
                })
              }
            />
          }
          label='Wert ist erforderlich'
        />
      </FormControl>
    </>
  );
};
